interface CorrectionSalaryCode {
  id: string
  name: string
  externalId: string
  isDiet: boolean
  isSalaryDay: boolean
}

export interface CorrectionOnlySalaryCode {
  id: string
  name: string
  salaryId: string
  /** Diets and salary days are counted, every other code is hours. */
  isCount: boolean
}

/**
 * Salary codes that only reach the salary basis through a manual correction,
 * so the month's calculated sums have no line for them. Once the month is
 * locked their transferred value still has to be shown for the table to add
 * up to the payslip.
 */
export function getCorrectionOnlySalaryCodes(
  corrections: Array<{ salaryCode: CorrectionSalaryCode }>,
  summedLines: Array<{ salaryId: string | null }>
): CorrectionOnlySalaryCode[] {
  const summedSalaryIds = new Set(summedLines.map(line => line.salaryId))
  const codes = new Map<string, CorrectionOnlySalaryCode>()

  for (const { salaryCode } of corrections) {
    if (
      summedSalaryIds.has(salaryCode.externalId) ||
      codes.has(salaryCode.externalId)
    )
      continue

    codes.set(salaryCode.externalId, {
      id: salaryCode.id,
      name: salaryCode.name,
      salaryId: salaryCode.externalId,
      isCount: salaryCode.isDiet || salaryCode.isSalaryDay,
    })
  }

  return [...codes.values()]
}

export function formatSalaryCodeCount(value: number | string | null) {
  return String(Math.round(Number(value ?? 0) * 100) / 100)
}
